var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "detailContainer",
    },
    [
      _c(
        "el-timeline",
        _vm._l(_vm.tableData, function (item, index) {
          return _c(
            "el-timeline-item",
            {
              key: index,
              attrs: { timestamp: item.createTime, placement: "top" },
            },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-form",
                    { staticClass: "operationData", attrs: { model: item } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "ip",
                            label: _vm.$t("basicData.OperationalIP") + "：",
                          },
                        },
                        [_c("div", [_vm._v(_vm._s(item.ip))])]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "operatorName",
                            label: _vm.$t("basicData.OperatorName") + "：",
                          },
                        },
                        [_c("div", [_vm._v(_vm._s(item.operatorName))])]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "createTime",
                            label: _vm.$t("basicData.OperationTime") + "：",
                          },
                        },
                        [_c("div", [_vm._v(_vm._s(item.createTime))])]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "operationContent",
                            label: _vm.$t("basicData.ActionContent") + "：",
                          },
                        },
                        _vm._l(
                          item.operationContent.split("\n"),
                          function (list, ind) {
                            return _c("div", { key: ind }, [
                              _vm._v(" " + _vm._s(list) + " "),
                              item.extra &&
                              ind ===
                                item.operationContent.split("\n").length - 1
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#00A551",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadQuote(item.extra)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("basicData.DownloadTheQuote")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              item.extraFilePath &&
                              ind ===
                                item.operationContent.split("\n").length - 1
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#00A551",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadQuote2(
                                            item.extraFilePath
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("basicData.DownloadTheQuote")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }